import Vue from 'vue';
import router from './router';
import store from './store';
import App from './App.vue';

// IMPORTANTE: Importar el CSS global
import '../../css/public-app.css';

// Configuración de Vue
Vue.config.productionTip = false;

// Event Bus para comunicación entre componentes
Vue.prototype.$eventBus = new Vue();

// Crear instancia de Vue
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');